<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">P Analysis</strong> <span
            v-if="(selTab !== 'S1 S' || selTab !== 'p Trends')">Company count: {{ selTab === 'P1S_Run_Update' ?
              p1SResultData.length : rawData.length }}</span>
        </div>
        <div class="col-md-3"
          v-if="(selTab !== 'S1 S' && selTab !== 'Return Analysis' && selTab !== 'S1S_Sector' && selTab !== 'S1S_Large_Cap' && selTab !== 'S1S_Mid_Cap' && selTab !== 'S1S_Small_Cap' && selTab !== 'P1S_Run_Update') && tabs.length > 0">
          <download :tableId="tabs[actTab]['title']" :fileName="tabs[actTab]['title'] + '-data'"></download>
        </div>
        <div class="col-md-3" v-if="(selTab === 'S1 S')">
          <download :tableId="'s1s'" :fileName="'s1-s-data'"></download>
        </div>
        <div class="col-md-3" v-if="(selTab === 'Return Analysis')">
          <download :tableId="'return-analysis'" :fileName="'return-analysis-data'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <div class="mb-15"></div>
          <pAnalysisData :title="alg.title" :pData="rawData" :mcFilter="mcOptions" :sectorList="sectors"
            :pfilterOptions="filterOptions" :pTableFields="tableFields" @filterD="filtData" @searchD="searchdata"
            @rangeFilt="rangeFilter" ref="panalysis"></pAnalysisData>
        </v-tab>
        <v-tab :title="'Return Analysis'">
          <div class="mb-15"></div>
          <returnAnalysis :mcFilter="mcOptions" :sectorList="sectors" ref="s1sum"></returnAnalysis>
        </v-tab>
        <v-tab :title="'S1 S'">
          <div class="mb-15"></div>
          <s1 :mcFilter="mcOptions" :sectorList="sectors" ref="s1sum"></s1>
        </v-tab>
        <v-tab :title="'p Trends'">
          <div class="mb-15"></div>
          <pTrends :isIndividual="1"></pTrends>
        </v-tab>
        <v-tab :title="'S1S_Sector'">
          <div class="col-md-3 mt-4 mb-2 pl-0">
            <div class="d-flex align-items-center m-1">
              Date: <v-select class="pl-0 w-100" :options="dateFilterTabWiseData" :placeholder="'Select Date'"
                v-model="ddate" @input="changeDateFilter($event)"></v-select>
            </div>
          </div>
          <s1sSector :sectorList="s1SSectorsData"></s1sSector>
        </v-tab>
        <v-tab :title="'S1S_Large_Cap'">
          <div class="col-md-3 mt-4 mb-2 pl-0">
            <div class="d-flex align-items-center m-1">
              Date: <v-select class="pl-0 w-100" :options="dateFilterTabWiseData" :placeholder="'Select Date'"
                v-model="ddate" @input="changeDateFilter($event)"></v-select>
            </div>
          </div>
          <s1sSector :sectorList="s1SSectorsData"></s1sSector>
        </v-tab>
        <v-tab :title="'S1S_Mid_Cap'">
          <div class="col-md-3 mt-4 mb-2 pl-0">
            <div class="d-flex align-items-center m-1">
              Date: <v-select class="pl-0 w-100" :options="dateFilterTabWiseData" :placeholder="'Select Date'"
                v-model="ddate" @input="changeDateFilter($event)"></v-select>
            </div>
          </div>
          <s1sSector :sectorList="s1SSectorsData"></s1sSector>
        </v-tab>
        <v-tab :title="'S1S_Small_Cap'">
          <div class="col-md-3 mt-4 mb-2 pl-0">
            <div class="d-flex align-items-center m-1">
              Date: <v-select class="pl-0 w-100" :options="dateFilterTabWiseData" :placeholder="'Select Date'"
                v-model="ddate" @input="changeDateFilter($event)"></v-select>
            </div>
          </div>
          <s1sSector :sectorList="s1SSectorsData"></s1sSector>
        </v-tab>
        <v-tab :title="'P1S_Run_Update'">
          <div class="col-md-4 mt-3 mb-2 pl-0 d-flex align-items-center g-2">
            <div class="d-flex align-items-center m-1">
              Date: <datepicker :input-class="'form-control'" style="padding-left: 0.5rem;" :format="'dd-MM-yyyy'"
                v-model="ddate" @selected="changeDateFilter($event)"></datepicker>
            </div>
            <div class="w-50 ml-2">
              <select class="form-control" v-model="p1sSectorsFilter" name="raw-data-columns">
                <option v-for="(d, index) in p1sSectorsFilterOptions" v-bind:key="d.id + index" :value="d.id">{{ d.value
                }}
                </option>
              </select>
            </div>
            <div class="ml-4">
              <button @click="p1sSectorsFilterClick" class="btn btn-sm btn-primary" type="button">
                <i class="fa fa-filter" title="Filter"></i>
              </button>
            </div>
          </div>
          <!-- <div class="col-md-1">
            <div class="form-group">
              <button @click="p1sSectorsFilterClick" class="btn btn-sm btn-primary" type="button">
                <i class="fa fa-filter" title="Filter"></i>
              </button>
            </div>
          </div> -->
          <p1sAnalysisResult :cronList="p1SResultData"></p1sAnalysisResult>
          <!-- <s1sSector :sectorList="s1SSectorsData"></s1sSector> -->
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import pAnalysisData from "@/views/market-data/p-analysis-data";
import returnAnalysis from "@/views/market-data/return-analysis";
import s1 from "@/views/market-data/s1-s";
import s1sSector from "@/views/market-data/s1s-sector";
import p1sAnalysisResult from "@/views/market-data/p1-s-analysis-result";
import pTrends from "@/views/company/pTrends";
export default {
  components: {
    Datepicker,
    pAnalysisData,
    pTrends,
    s1,
    returnAnalysis,
    s1sSector,
    p1sAnalysisResult
  },
  mixins: [commonMixins, pCommonMixins],
  created() {
    if (
      this.tabs[this.actTab].title !== "return-analysis" &&
      this.tabs[this.actTab].title !== "p9_S"
    ) {
      // console.log("P TABS");
      this.minRange = ["", ""];
      this.maxRange = ["", ""];
      this.selFilter = ["market_capitalization", this.tabs[this.actTab].title];
    } else {
      this.minRange = "";
      this.maxRange = "";
      this.selFilter = "";
    }
    console.log('### this.ddate ###', this.ddate);
    if (this.ddate == '') {
      this.ddate = new Date().setDate(new Date().getDate() - 1);
    }
    this.getPData();
    this.getSectorData();
  },
  data() {
    return {
      tabs: [
        { title: "p1_S", name: "P1 S", rawDataApi: "getPSumData" },
        { title: "p2_S", name: "P2 S", rawDataApi: "getPSumData" },
        { title: "p3_S", name: "P3 S", rawDataApi: "getPSumData" },
        { title: "p4_S", name: "P4 S", rawDataApi: "getPSumData" },
        { title: "p5_a_S", name: "P5 A S", rawDataApi: "getPSumData" },
        { title: "p5_b_S", name: "P5 B S", rawDataApi: "getPSumData" },
        { title: "p6_a", name: "P6 A S", rawDataApi: "getPSumData" },
        { title: "p6_b", name: "P6 B S", rawDataApi: "getPSumData" },
        { title: "p7_a_S", name: "P7 A S", rawDataApi: "getPSumData" },
        { title: "p7_b_S", name: "P7 B S", rawDataApi: "getPSumData" },
        { title: "p8_a_S", name: "P8 A S", rawDataApi: "getPSumData" },
        { title: "p8_b_S", name: "P8 B S", rawDataApi: "getPSumData" },
        { title: "p9_S", name: "P9 S", rawDataApi: "getP9SumData" },
        { title: "p10_S", name: "P10 S", rawDataApi: "getPSumData" },
        { title: "p11_S", name: "P11 S", rawDataApi: "getPSumData" },
        { title: "q1_S", name: "Q1 S", rawDataApi: "getPSumData" },
        { title: "q1_a_S", name: "Q1 A S", rawDataApi: "getPSumData" },
        { title: "q1_b_S", name: "Q1 B S", rawDataApi: "getPSumData" },
        { title: "q1_c_S", name: "Q1 C S", rawDataApi: "getPSumData" },
        { title: "q1_d_S", name: "Q1 D S", rawDataApi: "getPSumData" },
        { title: "q1_a_or_b", name: "Greater Q1 A/B", rawDataApi: "getPSumData" },
        { title: "quarterly_trends", name: "Quarterly Trends", rawDataApi: "getPSumData" },
        { title: "z1_S", name: "Z1 S", rawDataApi: "getPSumData" },
        // {
        //   title: "return-analysis",
        //   name: "Return Analysis",
        //   rawDataApi: "getReturnAnalysis"
        // }
      ],
      selTab: null, //"p1_S",
      actTab: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ],
      rawData: [],
      searchData: [],
      sectors: [],
      s1SSectorsData: [],
      p1SResultData: [],
      minRange: "",
      maxRange: "",
      selFilter: "",
      p1sSectorsFilter: null,
      p1sSectorsFilterOptions: [
        {
          id: "Pass",
          value: "Pass",
        },
        {
          id: "Fail",
          value: "Fail",
        }
      ],
      sectorname: "",
      //ddate: "",//new Date().setDate(new Date().getDate() - 1), //"", //
      ddate: new Date().setDate(new Date().getDate() - 1),
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      tableFields: [],
      rawDataApi: "getPSumData",
      isTabChanged: true,
      dateFilterTabWiseData: [],
    };
  },
  methods: {
    setDataFilter() {
      let self = this;
      console.log('this.selTab', self.selTab);
      //return;
      self.dateFilterTabWiseData = [];
      http.get(`mutual-funds/filter-date?collection_name=${this.selTab}`, {}, function (error, response) {
        console.log("Sector Data", response);
        if (response.responseType === 'success') {
          self.dateFilterTabWiseData = response.date;
        }
      });
    },
    getS1SDataApiCall() {
      let self = this;
      self.s1SSectorsData = [];
      let data = { "collection_name": self.selTab, "insert_date": self.ddate };
      http.post('frontend/profile_allocation_s1s_to_market/get', data, (error, response) => {
        console.log('response', response);
        if (response.responseType === "success") {
          self.s1SSectorsData = response.data;
        }
      });
    },
    getP1SResultDataApiCall() {
      let self = this;
      self.p1SResultData = [];
      let data = { "insert_date": new Date(self.ddate).toLocaleDateString('en-GB').replace(/\//g, '-'), "status": this.p1sSectorsFilter };
      http.post('frontend/p1_s_analysis_status/get', data, (error, response) => {
        console.log('response', response);
        if (response.status === "success") {
          self.p1SResultData = response.data;
        }
      });
    },
    p1sSectorsFilterClick() {
      //this.ddate = new Date(e).toLocaleDateString('en-US').replace(/\//g, '-');
      console.log('filter click', this.p1sSectorsFilter, this.ddate);
      this.getP1SResultDataApiCall();
    },
    getTabData(tabIndex, newTab, oldTab) {
      let self = this;
      self.ddate = null;
      this.selTab = newTab.title;
      this.actTab = tabIndex;
      console.log(tabIndex, newTab.title, oldTab);
      if (newTab.title === 'S1S_Sector' || newTab.title === 'S1S_Large_Cap' || newTab.title === 'S1S_Mid_Cap' || newTab.title === 'S1S_Small_Cap') {
        self.setDataFilter();
        self.getS1SDataApiCall();
        return;
      } else if (newTab.title === 'P1S_Run_Update') {

        //self.ddate = new Date().toLocaleDateString('en-US');
        self.ddate = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString('en-US').replace(/\//g, '-');
        //self.ddate = new Date().setDate(new Date().getDate() - 1);
        console.log('INIT DATE: ', self.ddate);
        self.getP1SResultDataApiCall();
      }


      if (tabIndex < 23) {
        this.actTab = tabIndex;
        this.rawDataApi = this.tabs[this.actTab].rawDataApi;
        if (this.tabs[this.actTab].title !== "p9_S") {
          // console.log("P TABS");
          this.minRange = ["", ""];
          this.maxRange = ["", ""];
          this.selFilter = [
            "market_capitalization",
            this.tabs[this.actTab].title
          ];
        } else {
          this.minRange = "";
          this.maxRange = "";
          this.selFilter = "";
        }
        this.sectorname = "";
        this.ddate = new Date().setDate(new Date().getDate() - 1);
        this.isTabChanged = true;
        this.filterOptions = [
          {
            id: "",
            value: "Select",
            isNumeric: true,
            sort_order: 0
          }
        ];
        this.getPData();
      }
    },
    getSectorData() {
      let _this = this;
      http.get("getSectorList", {}, function (error, response) {
        // console.log("Sector Data", response);
        _this.sectors = response;
      });
    },
    rangeFilter(e) {
      this.filterRangeData(e);
    },
    searchdata(e) {
      this.filteredList(e);
    },
    changeDateFilter(e) {
      console.log("Date Selected", e);

      console.log("=> ", this.selTab);
      if (this.selTab === 'S1S_Sector' || this.selTab === 'S1S_Large_Cap' || this.selTab === 'S1S_Mid_Cap' || this.selTab === 'S1S_Small_Cap') {
        this.ddate = e;
        this.getS1SDataApiCall();
        return;
      } else if (this.selTab === 'P1S_Run_Update') {
        this.ddate = new Date(e).toLocaleDateString('en-US').replace(/\//g, '-');

        console.log('this.ddate', this.ddate);
        //this.getP1SResultDataApiCall();
      }
    },
  },
  mounted() {
    this.p1sSectorsFilter = this.p1sSectorsFilterOptions[0].value;
  }

};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/p-analysis.vue